import request from "@/utils/request"
import mockedUser from "../../mock/user"

export function login(email, password) {
  return request({
    url: "/api/login",
    method: "post",
    params: {
      email,
      password
    }
  })
}

export function getInfo(token, mocked) {
  if (!mocked)
    return request({
      url: "/api/account",
      method: "get"
    })
  else {
    return Promise.resolve(
      mockedUser.getInfo({
        body: {
          token: "pharmacist-token"
        }
      })
    )
  }
}

export function logout(mocked) {
  if (!mocked)
    return request({
      url: "/user/logout",
      method: "post"
    })
  else {
    return Promise.resolve(mockedUser.logout())
  }
}

export function recoverPassword(email) {
  if (!email) throw new Error("Email wasn't provided")
  return request({
    url: "/api/password/create",
    method: "post",
    params: { email }
  })
}

export function resetPassword(params) {
  if (!params) throw new Error("Params weren't provided")
  return request({
    url: "/api/password/reset",
    method: "post",
    params
  })
}

export function checkToken(params) {
  if (!params) throw new Error("Params weren't provided")
  return request({
    url: "/api/token",
    method: "post",
    params
  })
}

export function loginAs(params) {
  if (!params) throw new Error("User's ID wasn't provided")

  return request({
    url: "/api/loginas/" + params.payload.user.id,
    method: "post"
  })
}
